import styles from './ContentPage.module.css';
import { Container, Row, Col } from 'react-bootstrap';
import ContentPageSidebar from './ContentPageSidebar.jsx';

function ContentPage({title, children}) {
  return (
    <div className={styles.ContentPage}>
      <Container className="p-4">
        <h1 className={styles.PageTitle}>{title}</h1>
        <Row>
          <Col md={8} className={styles.PageContent}>
            {children}
          </Col>
          <Col sm={false} md={4} className={styles.PageContentSidebar}>
            <ContentPageSidebar />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ContentPage
